import clsx from "clsx";
import pluralEN from "plural";
import pluralRU from "plural-ru";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import IconCheck from "~/components/Icons/icon-check-mark";
import IconCross from "~/components/Icons/icon-cross";
import Default from "~/components/Icons/icon-default";
import IconDownload from "~/components/Icons/icon-download";
import Edit from "~/components/Icons/icon-edit-2";
import Button from "~/shared/ui/Fields/Button";
import DatesPicker from "~/shared/ui/Fields/DatePicker";
import Select from "~/shared/ui/Fields/SelectZD";
import {
  CHECK_OPTIONS,
  CHECK_OPTIONS_COMPLIANCE,
  CHECK_OPTIONS_IS_OUTSOURCING,
  CHECK_OPTIONS_IS_RESOLVE,
  ROW_CHECK_OPTIONS_DATE,
  ROW_CHECK_OPTIONS_INPUT,
  ROW_CHECK_OPTIONS_SELECT,
} from "~/components/Table/TableRow/ZDTableRow/options";
import { NOTIFICATIONS } from "~/constans/notifications";
import { useSetLocationData } from "~/hooks/locationData";
import { useURLParamsSetter } from "~/hooks/useURLParamsSetter";
import { getFormatDate } from "~/libs/getFormatDate";
import { uploadFile } from "~/libs/uploadFile";
import { useAddNotificationMutation } from "~/schemas/generated/graphql";
import { usePermissions } from "~/shared/context/PermissionContext";
import { Field } from "~/shared/ui/Field";
import { Input } from "~/shared/ui/Fields/Input";

import s from "~/components/Table/TableRow/ZDTableRow/TableRow.less";

const excludedOptionsForEditIdPersonal = [
  "id",
  "PersonName",
  "Position",
  "PositionStart",
  "StudyCertificateDate",
];

interface IProps {
  arrObjects?: any[];
  item: any;
  options: string[];
  openModal: string;
  currentId: string;
  control?: any;
  selected?: string;
  rowType?: string;
  datenews?: string;
  imgArr?: string[];
  loading: boolean;
  onSubmit?: any;
  handleSubmit?: any;
  setValue?: any;
  selectParent?: string;
  errors?: any;
  onSumbitDublicate?: any;
  hasEdit: boolean;
  hasAnyCheck: boolean;
  hasAllCheck: boolean;
  isOnlyView: boolean;
  isImage: (name: string) => JSX.Element;
  CheckedDate?: Date;
  handleDeleteRow: (uuid: string) => () => void;
  parentObject?: any;
  type?: string;
}

const DefaultOldSubRow: React.FC<IProps> = ({
  // fields
  arrObjects,
  item,
  options,
  openModal,
  currentId,
  control,
  selected,
  rowType,
  datenews,
  loading,

  // actions
  onSubmit,
  handleSubmit,
  setValue,
  selectParent,
  errors,
  onSumbitDublicate,

  // permissions
  hasEdit,
  hasAnyCheck,
  hasAllCheck,
  isOnlyView,
  isImage,
  CheckedDate,
  handleDeleteRow,

  parentObject,
  type,
}) => {
  // rowType — тип строки (приоритет), selected — вкладка из URL (fallback)
  const effectiveRowType = rowType ?? selected;
  const setData = useSetLocationData();
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const serParams = useURLParamsSetter();

  const { t } = useTranslation();
  const [uploadFileLoader, setUploadFileLoader] = useState(false);
  const [addNotificationMutation] = useAddNotificationMutation({});
  const lang = localStorage.getItem("language");
  const isEn = lang === "en";

  const arrFilter = (arr) =>
    !!arr && filterCombine.filter(({ value }) => value === arr)[0];

  const onButtonClick = (opens) => {
    switch (opens) {
      case "Compliance":
        if (effectiveRowType === "personal") {
          serParams({
            openModal: opens,
            currentId: item.instanceId,
            PlanReportId: item.planReportId || item.id,
          });
        } else {
          serParams({
            openModal: opens,
            currentId: item.UUID,
            PlanReportId: item.planReportId || item.id,
          });
        }
        break;
      case "Files":
      case "Image":
        if (effectiveRowType === "personal") {
          serParams({
            openModal: opens,
            currentId: item.zdPersonalId ?? parentObject?.zdPersonalId ?? item.id,
            PlanReportId: item.planReportId || item.id,
          });
        } else {
          serParams({
            openModal: opens,
            currentId: item.ZD_UUID || item.UUID,
            PlanReportId: item.planReportId || item.id,
          });
        }
        break;
      default:
        serParams({
          openModal: opens,
          currentId: item.UUID,
          PlanReportId: item.planReportId || item.id,
        });
    }
  };

  const onButtonComment = () => {
    serParams({
      openModal: "Comment",
      currentId: item.zdPersonalId,
      PlanReportId: item.planReportId || item.id,
    });
  };

  const itemHasAdditionalFilesCount = () => {
    const keys = ["dataConsent", "positionOrder", "photo", "jobDescription"];
    return keys.reduce((acc, key) => (item[key] != null ? acc + 1 : acc), 0);
  };

  const totalFiles = (optionName: string) =>
    (item[optionName]?.length || 0) + itemHasAdditionalFilesCount();

  const filterCombine =
    arrObjects && arrObjects.filter(({ value }) => item.UUID !== value);

  const onCrossClickBtn = () => {
    setData("openModal", "");
  };

  const onCrossClick = () => {
    setData("openModal", "", "currentId", "");
  };

  const lvlCehck =
    !loading && Object.keys(item).includes("lvl") && item["lvl"] === 0;

  return (
    <tr
      className={clsx(s.row_tr, {
        [s.row_lvl_0]: lvlCehck,
      })}
    >
      {lvlCehck ? (
        <>
          <td>
            {t("zd.plot")}: {item.Name}
          </td>
          <td />
          <td />
        </>
      ) : (
        options?.map((optionName) => {
          const count = totalFiles(optionName);
          return (
            <>
              <td
                className={clsx({
                  [s.wrapComplince]: optionName === "Compliance",
                })}
                data-option_name={optionName}
              >
                <div className={s.divWrapper}>
                  {ROW_CHECK_OPTIONS_SELECT.includes(optionName) ? (
                    openModal === optionName && currentId === item.UUID ? (
                      <div
                        className={clsx(s.divWrapper, {
                          [s.wrapperRow]: currentId === item.UUID,
                        })}
                      >
                        <Select
                          name={optionName}
                          type="zd"
                          key={`${item["id"]}${optionName}`}
                          control={control}
                          defaultValue={item[optionName]}
                          optionObjects={CHECK_OPTIONS}
                          onChanges={onSubmit}
                          vertical
                          customClassName={s.selectEditor}
                        />
                        <Button
                          customClassName={s.normolizeBtn}
                          txtBtn={""}
                          onlyIcon
                          isForm
                          onClick={onCrossClick}
                        >
                          <IconCross />
                        </Button>
                      </div>
                    ) : (
                      <>
                        <span className={s.icon_default}>
                          <img
                            src={item[optionName].icon}
                            alt={item[optionName].label}
                          />
                        </span>
                        {hasEdit && (
                          <Button
                            customClassName={s.edit_changes}
                            txtBtn={""}
                            onlyIcon
                            onClick={() => onButtonClick(optionName)}
                          >
                            <Edit />
                          </Button>
                        )}
                      </>
                    )
                  ) : optionName === "Image" &&
                    effectiveRowType &&
                    effectiveRowType !== "notes" &&
                    effectiveRowType !== "personal" ? (
                    openModal === optionName && currentId === item.UUID ? (
                      <form
                        className={clsx(s.divWrapper, {
                          [s.wrapperRow]: currentId === item.UUID,
                        })}
                        onSubmit={handleSubmit(onSubmit)}
                      >
                        {item.Image && (
                          <a
                            href={item.Image}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <IconDownload fill={"#878E94"} />
                          </a>
                        )}
                        <Field
                          type="file"
                          name="Image"
                          control={control}
                          accept={[
                            "image/png",
                            "image/jpeg",
                            "application/pdf",
                            "application/vnd.ms-excel",
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                          ]}
                          loading={uploadFileLoader}
                          className={s.fileField}
                          onUpload={async (file) => {
                            setUploadFileLoader(true);
                            try {
                              const uploaded = await uploadFile(file, () =>
                                addNotificationMutation({
                                  variables: {
                                    type: NOTIFICATIONS.error,
                                    content: t("common.data_uploaded_error"),
                                  },
                                })
                              );
                              if (uploaded) {
                                // Режим пикера: onUpload ничего не возвращает,
                                // значение поля в форме не меняется — id файла
                                // пишем в Image сами.
                                setValue("Image", uploaded.id);
                                addNotificationMutation({
                                  variables: {
                                    type: NOTIFICATIONS.success,
                                    content: t(
                                      "common.file_uploaded_successfully"
                                    ),
                                  },
                                });
                              }
                            } finally {
                              setUploadFileLoader(false);
                            }
                          }}
                        />
                        <Button
                          customClassName={s.normolizeBtn}
                          txtBtn={""}
                          onlyIcon
                          isForm
                        >
                          <IconCheck />
                        </Button>
                        <Button
                          customClassName={s.normolizeBtn}
                          txtBtn={""}
                          onlyIcon
                          onClick={onCrossClick}
                        >
                          <IconCross />
                        </Button>
                      </form>
                    ) : (
                      <>
                        {!item.Image ? (
                          (hasEdit || hasAllCheck) && (
                            <div
                              style={{
                                color: "#439edd",
                                cursor: "pointer",
                                textAlign: "center",
                              }}
                              onClick={() => onButtonClick(optionName)}
                            >
                              {lang === "en"
                                ? `Download \nscan copy`
                                : `Загрузить\nскан-копию`}
                            </div>
                          )
                        ) : (
                          <>
                            <span className={s.icon_default}>
                              <div className={s.fileImg}>
                                {isImage(item[optionName])}
                              </div>
                            </span>

                            {(hasEdit) && (
                              <Button
                                customClassName={s.edit_changes}
                                txtBtn={""}
                                onlyIcon
                                onClick={() => onButtonClick(optionName)}
                              >
                                <Edit />
                              </Button>
                            )}
                          </>
                        )}
                      </>
                    )
                  ) : optionName === "Compliance" ? (
                    openModal === optionName &&
                    (currentId === item.UUID ||
                      String(currentId) === String(item.instanceId)) ? (
                      <div
                        className={clsx(s.divWrapper, {
                          [s.wrapperRow]: currentId === item.UUID,
                        })}
                      >
                        <Select
                          name={`Compliance`}
                          type="zd"
                          key={`${item["id"]}Compliance`}
                          control={control}
                          defaultValue={item[optionName]}
                          optionObjects={CHECK_OPTIONS_COMPLIANCE}
                          vertical
                          onChanges={
                            effectiveRowType === "personal" ? onSubmit(item) : onSubmit
                          }
                          customClassName={s.selectEditor}
                        />
                        <Button
                          customClassName={s.normolizeBtn}
                          txtBtn={""}
                          onlyIcon
                          isForm
                          onClick={onCrossClick}
                        >
                          <IconCross />
                        </Button>
                        {hasAnyCheck &&
                          !isOnlyView &&
                          !!(item.planReportId || item.id) &&
                          !item.Compliance.value && (
                            <>
                              <Button
                                customClassName={s.edit_changes}
                                txtBtn={t("ui.comment")}
                                small
                                onClick={() => onButtonComment()}
                              >
                                {/*<Edit />*/}
                              </Button>
                            </>
                          )}
                      </div>
                    ) : (
                      <>
                        <span className={s.icon_default}>
                          <img
                            src={item[optionName].icon}
                            alt={item[optionName].label}
                          />
                        </span>
                        {hasAnyCheck && !isOnlyView && (
                          <Button
                            customClassName={s.edit_changes}
                            txtBtn={""}
                            onlyIcon
                            onClick={() => onButtonClick("Compliance")}
                          >
                            <Edit />
                          </Button>
                        )}
                        {hasAnyCheck &&
                          !isOnlyView &&
                          !!(item.planReportId || item.id) &&
                          !item.Compliance.value && (
                            <>
                              <Button
                                customClassName={s.edit_changes}
                                txtBtn={t("ui.comment")}
                                small
                                onClick={() => onButtonComment()}
                              >
                                {/*<Edit />*/}
                              </Button>
                            </>
                          )}
                      </>
                    )
                  ) : ROW_CHECK_OPTIONS_INPUT.map((el) => el.name).includes(
                      optionName
                    ) ? (
                    openModal === optionName && currentId === item.UUID ? (
                      <form
                        className={clsx(s.divWrapper, {
                          [s.wrapperRow]: currentId === item.UUID,
                        })}
                        onSubmit={handleSubmit(onSubmit)}
                      >
                        <Input
                          name={optionName}
                          control={control}
                          maxLength={255}
                          type={((): string => {
                            const names = ROW_CHECK_OPTIONS_INPUT.map(
                              (el) => el.name
                            );
                            return ROW_CHECK_OPTIONS_INPUT[
                              names.indexOf(optionName)
                            ].type;
                          })()}
                          min={0}
                          step={
                            optionName !== "Area"
                              ? selectParent !== "requiredTools" &&
                                optionName !== "Total"
                                ? 1
                                : 0.01
                              : 0.01
                          }
                          error={
                            optionName === "CertificationDate" &&
                            errors["CertificationDate"]?.message
                          }
                          defaultValue={
                            item[optionName] === null
                              ? ""
                              : String(
                                  selectParent !== "requiredTools" &&
                                    optionName !== "Total"
                                    ? item[optionName]
                                    : Math.floor(
                                        Number(item[optionName]) * 100
                                      ) / 100
                                )
                          }
                          customClassName={s.input_edit}
                        />
                        {optionName === "CertificationDate" &&
                          (hasEdit) && (
                            <>
                              <span className={s.trable}>
                                {`${t("zd.outsourcing_agreement")}:`}
                                <Select
                                  name={`FactContract`}
                                  type="zd"
                                  key={`${item["id"]}FactContract`}
                                  control={control}
                                  error={
                                    optionName === "CertificationDate" &&
                                    errors["FactContract"]?.value?.message
                                  }
                                  defaultValue={item["FactContract"]}
                                  optionObjects={CHECK_OPTIONS_IS_OUTSOURCING}
                                  vertical
                                  customClassName={s.selectEditor}
                                />
                              </span>
                            </>
                          )}
                        <Button
                          customClassName={s.normolizeBtn}
                          txtBtn={""}
                          onlyIcon
                          isForm
                        >
                          <IconCheck />
                        </Button>

                        <Button
                          customClassName={s.normolizeBtn}
                          txtBtn={""}
                          onlyIcon
                          isForm
                          onClick={onCrossClick}
                        >
                          <IconCross />
                        </Button>
                      </form>
                    ) : (
                      <>
                        <span className={s.cont}>
                          {optionName === "CertificationDate" &&
                          hasAnyCheck &&
                          !isOnlyView &&
                          !!item["FactContract"].value
                            ? `${t("usouo.FactContract")}: ${
                                item[optionName] ? item[optionName] : ""
                              }`
                            : (() => {
                                if (typeof item[optionName] === "string") {
                                  if (
                                    optionName === "PersonName" &&
                                    effectiveRowType === "personal" &&
                                    item.id
                                  ) {
                                    return (
                                      <Link
                                        to={`/base/viewing/${item.id}`}
                                        style={{ cursor: "pointer" }}
                                      >
                                        {item[optionName]}
                                      </Link>
                                    );
                                  }
                                  return item[optionName];
                                }
                                if (typeof item[optionName] === "number") {
                                  return optionName === "Total"
                                    ? Math.floor(
                                        Number(item[optionName]) * 100
                                      ) / 100
                                    : item[optionName];
                                }
                                // Числовые поля (Total, Area, Year) могут прийти строкой из API/пайпа
                                if (
                                  ["Total", "Area", "Year"].includes(optionName)
                                ) {
                                  if (
                                    item[optionName] === null ||
                                    item[optionName] === undefined
                                  ) {
                                    return "";
                                  }
                                  if (typeof item[optionName] === "string") {
                                    const num = Number(item[optionName]);
                                    if (!Number.isNaN(num)) {
                                      return optionName === "Total"
                                        ? Math.floor(num * 100) / 100
                                        : num;
                                    }
                                  }
                                }
                                if (Array.isArray(item[optionName])) {
                                  return item[optionName]
                                    .map((el) => el.name)
                                    .filter((name) => {
                                      return name !== parentObject.Name;
                                    })
                                    .join(", ");
                                }
                                return "";
                              })()}
                        </span>
                        {optionName === "CertificationDate" &&
                          (hasEdit || hasAllCheck) && (
                            <span className={s.trable}>
                              {item["CertificationDate"] && (
                                <>
                                  {t("zd.outsourcing_agreement")}:
                                  <span
                                    className={clsx(
                                      s.icon_default,
                                      s.icon_left
                                    )}
                                  >
                                    <img
                                      src={item["FactContract"].icon}
                                      alt={item["FactContract"].label}
                                    />
                                  </span>
                                </>
                              )}
                            </span>
                          )}
                        {((hasEdit &&
                          !excludedOptionsForEditIdPersonal.includes(
                            optionName
                          ) &&
                          optionName !== "Address") ||
                          (hasAnyCheck && !isOnlyView && optionName === "reason") ||
                          (optionName === "Address" &&
                            item.GroupOne === "storageSites" &&
                            hasEdit)) && (
                          <Button
                            customClassName={clsx(
                              s.edit_changes,
                              s.edit_changes_input
                            )}
                            txtBtn={""}
                            onlyIcon
                            onClick={() => onButtonClick(optionName)}
                          >
                            <Edit />
                          </Button>
                        )}
                      </>
                    )
                  ) : ROW_CHECK_OPTIONS_DATE.includes(optionName) ? (
                    openModal === optionName && currentId === item.UUID ? (
                      <form
                        className={clsx(s.divWrapper, {
                          [s.wrapperRow]: currentId === item.UUID,
                        })}
                        onSubmit={handleSubmit(onSubmit)}
                      >
                        <DatesPicker
                          name={optionName}
                          control={control}
                          gray
                          customClassName={s.date_q}
                          dateFormat={"dd.MM.yyyy"}
                          defaultValue={
                            item[optionName] === null ||
                            item[optionName] === undefined
                              ? new Date()
                              : optionName === "CheckedDate"
                              ? new Date(datenews)
                              : new Date(item[optionName])
                          }
                        />
                        <Button
                          customClassName={s.normolizeBtn}
                          txtBtn={""}
                          onlyIcon
                          isForm
                        >
                          <IconCheck />
                        </Button>

                        <Button
                          customClassName={s.normolizeBtn}
                          txtBtn={""}
                          onlyIcon
                          isForm
                          onClick={onCrossClick}
                        >
                          <IconCross />
                        </Button>
                      </form>
                    ) : (
                      <>
                        {item[optionName] !== null ? (
                          <span className={s.cont}>
                            {optionName === "CheckedDate"
                              ? getFormatDate(CheckedDate, true)
                              : getFormatDate(new Date(item[optionName]), true)}
                          </span>
                        ) : (
                          <span className={s.cont}>{item[optionName]}</span>
                        )}
                        {hasEdit &&
                          !excludedOptionsForEditIdPersonal.includes(
                            optionName
                          ) && (
                            <Button
                              customClassName={clsx(
                                s.edit_changes,
                                s.edit_changes_input
                              )}
                              txtBtn={""}
                              onlyIcon
                              onClick={() => onButtonClick(optionName)}
                            >
                              <Edit />
                            </Button>
                          )}
                      </>
                    )
                  ) : optionName === "fixedAt" ? (
                    item.fixedAt ? (
                      <div>
                        {item.fixedAt &&
                          getFormatDate(new Date(item[optionName]), true)}
                      </div>
                    ) : hasEdit || hasPermission("zd.planReports.set") ? (
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <Button
                          customClassName={s.save_changes}
                          txtBtn={t("zd.corrected")}
                          small
                          orange
                          isForm
                          onClick={() => onButtonClick(optionName)}
                        >
                          <IconCheck />
                        </Button>
                      </form>
                    ) : (
                      <div>
                        {item.fixedAt &&
                          getFormatDate(new Date(item[optionName]), true)}
                      </div>
                    )
                  ) : optionName === "isResolved" ? (
                    openModal === optionName &&
                    currentId === item.UUID &&
                    hasPermission('zd.planReports.dealerfix') &&
                    !isOnlyView ? (
                      <div
                        className={clsx(s.divWrapper, {
                          [s.wrapperRow]: currentId === item.UUID,
                        })}
                      >
                        <Select
                          name={`isResolved`}
                          type="zd"
                          key={`${item["id"]}isResolved`}
                          control={control}
                          defaultValue={item[optionName]}
                          optionObjects={CHECK_OPTIONS_IS_RESOLVE}
                          vertical
                          onChanges={onSubmit}
                          customClassName={s.selectEditor}
                        />
                        <Button
                          customClassName={s.normolizeBtn}
                          txtBtn={""}
                          onlyIcon
                          isForm
                          onClick={onCrossClick}
                        >
                          <IconCross />
                        </Button>
                      </div>
                    ) : (
                      <>
                        <span className={s.icon_default}>
                          <img
                            src={item["isResolved"].icon}
                            alt={item["isResolved"].label}
                          />
                        </span>
                        {hasPermission('zd.planReports.dealerfix') && !isOnlyView && (
                          <Button
                            customClassName={s.edit_changes}
                            txtBtn={""}
                            onlyIcon
                            onClick={() => onButtonClick("isResolved")}
                          >
                            <Edit />
                          </Button>
                        )}
                      </>
                    )
                  ) : optionName === "Files" ||
                    ((effectiveRowType === "notes" || effectiveRowType === "personal") &&
                      optionName === "Image") ? (
                    <div>
                      {count > 0 && (
                        <span className={s.spanBig}>
                          {isEn
                            ? `${pluralEN("File", "Files", count)} ${count}`
                            : pluralRU(
                                count,
                                "Файл %d",
                                "Файла %d",
                                "Файлов %d"
                              )}
                        </span>
                      )}
                      {((item[optionName] && item[optionName].length > 0) ||
                        hasEdit ||
                        hasAllCheck ||
                        hasAnyCheck ||
                        (effectiveRowType === "notes" && hasPermission("zd.notesEdit")) ||
                        (effectiveRowType === "personal" && hasPermission("zd.personalEdit"))) && (
                        <Button
                          customClassName={s.butAddForm}
                          txtBtn={t("planReport.planReportFiles")}
                          small
                          orange
                          isForm
                          onClick={() => onButtonClick(optionName)}
                        />
                      )}
                    </div>
                  ) : optionName === "PlacesCombine" ||
                    optionName === "Combine" ? (
                    openModal === optionName && currentId === item.UUID ? (
                      <div
                        className={clsx(s.divWrapper, {
                          [s.wrapperRow]: currentId === item.UUID,
                        })}
                      >
                        <Select
                          name={optionName}
                          key={`${item["UUID"]}${optionName}`}
                          control={control}
                          defaultValue={
                            item[optionName]
                              ? arrFilter(item[optionName])
                              : {
                                  value: null,
                                  label: t("zd.not_combine"),
                                }
                          }
                          optionObjects={[
                            {
                              value: null,
                              label: t("zd.not_combine"),
                            },
                            ...filterCombine,
                          ]}
                          vertical
                          isNoLabel
                          onChanges={onSubmit}
                          customClassName={s.selectCombine}
                        />
                        <Button
                          customClassName={s.normolizeBtn}
                          txtBtn={""}
                          onlyIcon
                          isForm
                          onClick={onCrossClick}
                        >
                          <IconCross />
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <span className={s.cont}>
                          {arrFilter(item[optionName]) &&
                            arrFilter(item[optionName])["label"]}
                        </span>
                        {(hasEdit || hasAllCheck) && (
                          <Button
                            customClassName={clsx(
                              s.edit_changes,
                              s.edit_changes_input
                            )}
                            txtBtn={""}
                            onlyIcon
                            onClick={() => onButtonClick(optionName)}
                          >
                            <Edit />
                          </Button>
                        )}
                      </div>
                    )
                  ) : (
                    (!onSumbitDublicate || optionName === "id") && (
                      <span className={s.cont}>
                        {optionName === "Number" && item.parentNumber
                          ? `${item.parentNumber}.${item[optionName]}`
                          : optionName === "groupArea"
                          ? t(`${item[optionName]}`)
                          : optionName === "groupTrade"
                          ? t(`zd.${item[optionName]}`)
                          : item[optionName]}
                      </span>
                    )
                  )}
                </div>
              </td>
            </>
          );
        })
      )}

      {type !== "planReport" && ["requiredTools", "tools"].includes(effectiveRowType) && (
        <td>
          <Button
            customClassName={s.deleteRow}
            txtBtn={""}
            onlyIcon
            onClick={handleDeleteRow(item.UUID)}
          >
            <IconCross />
          </Button>
        </td>
      )}
      {options.includes("Image") &&
        effectiveRowType &&
        effectiveRowType !== "notes" &&
        effectiveRowType !== "personal" && (
          <td>
            {item.Image && (
              <div>
                <a href={item.Image} download>
                  <Button
                    small
                    txtBtn={t("pkd.download")}
                    customClassName={s.wide_btn}
                  >
                    <Default />
                  </Button>
                </a>
              </div>
            )}
          </td>
        )}
    </tr>
  );
};

export default DefaultOldSubRow;
